import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { LinkTW } from 'tailwindComponents/link/LinkTW';
import { clientUrls } from 'ui-toolkit/rest/ClientUrlFactory';

interface IDisbursementsButton {
  orderId: string;
}

export const DisbursementsButton: React.FC<IDisbursementsButton> = ({ orderId }) => {
  return (
    <LinkTW isButton to={clientUrls.urlFor.feesDisburseAll(orderId)} className={'flex items-center gap-1'}>
      <FontAwesomeIcon data-test-id="search-icon" icon={faSearch} />
      Disbursements
    </LinkTW>
  );
};
